export const deleteItem = (map: any, key: string, value: number | boolean) => {
    map.geoObjects.each((item: any, index: number) => {
        if (item.properties.get(key) === value) {
            const entryObject = map.geoObjects.get(index);
            if (entryObject) {
                map.geoObjects.remove(entryObject);
            }
        }
    })
}